// extracted by mini-css-extract-plugin
export default {"Spinner":"Spinner_Spinner__HIIde","loader":"Spinner_loader__x0fgV","large":"Spinner_large__4RoL2"};